import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";

import { Attendee } from "../../../api";
import { useTypedSelector } from "../../../store/models/root.interface";
import { fetchEventsForAttendee } from "../../../store/actions/attendees.actions";
import Loader from "../../../common/components/Loader";
import AttendeeScores from "../../../components/Events/AttendeeScores";
import AttendeeDetails from "../../../components/Events/AttendeeDetails";
import AttendeeEvents from "../../../components/Events/AttendeeEvents";
import ErrorBoundary from "../../../common/helpers/ErrorBoundary";

const AttendeeInfoSidebar = () => {

  const dispatch = useDispatch();

  const period = useTypedSelector(state => state.event.period);
  const attendeesState = useTypedSelector(state => state.attendees.data);
  const attendeeEventsState = useTypedSelector(state => state.attendees.selected.attended);
  const attendeeId = useTypedSelector((state) => state.attendees.attendeeId ?? null);

  const attendeeEvents = useMemo(() => typeof attendeeEventsState !== "string" ? attendeeEventsState : void 0, [attendeeEventsState]);

  const attendee = useMemo(() => {
    if (attendeeId && attendeesState && typeof attendeesState !== "string") {
      for (let i = 0; i < attendeesState.length; i++) {
        let attendee = attendeesState[i];
        if (attendee.id === attendeeId) {
          return attendee;
        }
      }
    }
    const attendee: Attendee = {
      id: attendeeId ?? "",
      totalEvents: 0,
    };
    return attendee;
  }, [attendeeId, attendeesState]);

  useEffect(() => {
    async function fetchData() {
      if (attendeeId) {
        dispatch(fetchEventsForAttendee(attendeeId, period));
      }
    }
    fetchData();
  }, [attendeeId, period]);

  return (
    <>

      <div className="m-3">
        <ErrorBoundary>
          <AttendeeDetails {...attendee} />
        </ErrorBoundary>
      </div>

      <div className="m-3">
        <ErrorBoundary>
          <div className="position-relative">
            <AttendeeEvents data={attendeeEvents} />
            <Loader show={attendeeEventsState === "loading"} />
          </div>
        </ErrorBoundary>
      </div>

      {!!attendee?.scores && (
        <div className="m-3">
          <ErrorBoundary>
            <AttendeeScores isAverage data={attendee.scores} />
          </ErrorBoundary>
        </div>
      )}

    </>
  );
};

export default AttendeeInfoSidebar;
